import { LoanReturnValues, LoanReturnResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

// Net return = (loan amount * expected return %) - (loan amount * interest %)
export function calculateLoanReturn(values: LoanReturnValues, t?: ToolsTranslations['loanReturn']): LoanReturnResult {
  const { loanAmount, interestPercent, expectedReturnPercent } = values;
  if (loanAmount < 0) return { netAmountPerYear: null, netPercentPerYear: null, isValid: false, message: t?.invalid.loanAmount };
  if (interestPercent < 0) return { netAmountPerYear: null, netPercentPerYear: null, isValid: false, message: t?.invalid.interestPercent };
  if (expectedReturnPercent < 0) return { netAmountPerYear: null, netPercentPerYear: null, isValid: false, message: t?.invalid.expectedReturnPercent };

  const interestCost = loanAmount * (interestPercent / 100);
  const grossReturn = loanAmount * (expectedReturnPercent / 100);
  const net = grossReturn - interestCost;
  const netPercent = (net / loanAmount) * 100;

  const netRounded = Math.round(net);
  const netPercentRounded = Math.round(netPercent * 100) / 100;

  if (!isFinite(netRounded) || !isFinite(netPercentRounded)) {
    return { netAmountPerYear: null, netPercentPerYear: null, isValid: false, message: t?.invalid.generic };
  }

  return { netAmountPerYear: netRounded, netPercentPerYear: netPercentRounded, isValid: true };
}


